import { render, staticRenderFns } from "./WarningSvg.vue?vue&type=template&id=5352cc49"
import script from "./WarningSvg.vue?vue&type=script&lang=js"
export * from "./WarningSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports